import React from 'react'
import { useState, useEffect } from "react"
import { Col } from "reactstrap"
import { useTranslation } from 'react-i18next'
import * as toastr from "toastr"
import Styled from 'styled-components'
import moment from 'moment'

import getConfig from "Placements/Utils/GetRequestConfig.util"
import Loader from "Placements/Components/Loader"
import BoxWhite from "Placements/Components/BoxWhite"
import API from 'Placements/API'
import TestReports from 'Placements/Components/TestReport'
import Breadcrumb from 'Placements/Components/Breadcrumb'
import { ContainerFlex } from "Placements/Styles/Global.style";

const ContainerFlexStyled = Styled(ContainerFlex)`
    .page_map{
        font-weight: 600;
        color: #66279b !important;

        a{
            text-decoration: none;
            color: #66279b !important;
        }

        a: hover{
            text-decoration: underline;
        }
    }
`

const DivStyled = Styled.div`
    margin: 2rem auto;
`

const TestListDetails = (props: any) => {

    const [isLoading, setLoading] = useState(true)
    const [userInfo, setUserInfo] = useState(null)
    const [lastPart, setLastPart] = useState(null)
    const [corretas, setCorretas] = useState(null)
    const [filterTeste, setFilterTeste] = useState(null)
    const [total, setTotal] = useState(null)
    const [lastScore, setLastScore] = useState(null)

    const { t, i18n } = useTranslation()
    const { match: { params } } = props

    useEffect(() => {
        API.Usuario.GetInfo({ idTesteUsuario: params.idTesteUser }, getConfig())
            .then((response: any) => setUserInfo(response.data))
            .catch((error: any) => {
                toastr.error('Não foi possível recuperar informações', '');
                setLoading(false)
            })

        API.TesteParte.GetInfoLastPart({ idTesteUsuario: params.idTesteUser }, getConfig())
            .then((response: any) => setLastPart(response.data))
            .catch((error: any) => {
                toastr.error('Não foi possível recuperar informações', '');
                setLoading(false)
            })

        API.Questoes.Corretas({ idTesteUsuario: params.idTesteUser }, getConfig())
            .then((response: any) => setCorretas(response.data))
            .catch((error: any) => {
                toastr.error('Não foi possível recuperar informações', '');
                setLoading(false)
            })

        API.Questoes.Total({ idTesteUsuario: params.idTesteUser }, getConfig())
            .then((response: any) => setTotal(response.data))
            .catch((error: any) => {
                toastr.error('Não foi possível recuperar informações', '');
                setLoading(false)
            })
    }, [])


    useEffect(() => {
        if (userInfo) {
            API.Admin.GetTestsFilter({ idTeste: params.idTesteUser, pagina: 1 }, getConfig())
                .then((response: any) => setFilterTeste(response.data))
                .catch((error: any) => {
                    toastr.error('Não foi possível recuperar informações', '');
                    setLoading(false)
                })
        }
    }, [userInfo])

    useEffect(() => {
        if (lastPart) {
            API.TesteUsuario.Get({ id: lastPart.Id_Teste_Usuario }, getConfig())
                .then((resp: any) => {

                    if (resp.data.Id_Versao_Teste) {
                        switch (resp.data.Id_Versao_Teste) {
                            case 1: i18n.changeLanguage('en'); break;
                            case 2: i18n.changeLanguage('es'); break;
                            default: i18n.changeLanguage('en');
                        }
                    }
                })
        }
    }, [lastPart])

    useEffect(() => {
        if (userInfo && lastPart && corretas != null && total != null) {
            setLoading(false)
        }
    }, [userInfo, lastPart, corretas, total])

    const getLastScore = (obj: any) => {
        setLastScore(obj)
    }

    const getBreadcrumb = () => {
        return [
            { path: "/admin/test-list", label: "Listagem de Testes" },
            { path: "", label: "Detalhes do teste" },
        ]
    }

    if (isLoading) return <Loader />

    return <ContainerFlexStyled>
        <Col md={10}>
            <Breadcrumb links={getBreadcrumb()} />
            <DivStyled>
                {userInfo && <BoxWhite>
                    <div className="resume">
                        <h1>{userInfo.Nome}</h1>
                        <div className="infos">
                            <div className="item"><strong>Email:&nbsp;</strong>{userInfo.Email}</div>
                            <div className="item"><strong>Telefone:&nbsp;</strong>{userInfo.Telefone}</div>
                            <div className="item"><strong>Cidade:&nbsp;</strong>{userInfo.Cidade}</div>
                        </div>
                    </div>

                    <div className="answers line-box">
                        <div className="details">
                            <div className="left">
                                <div><strong>Teste:</strong> {params.idTesteUser}</div>
                                <div><strong>Início:</strong> {moment(lastPart.Data_Inicio).format('DD/MM/yyyy HH:mm:ss')}</div>
                                <div><strong>Termino:</strong> {moment(lastPart.Data_Fim).format('DD/MM/yyyy HH:mm:ss')}</div>
                                <div><strong>{corretas} acertos</strong> de {total} questões</div>
                            </div>
                            <div className="right">
                                {lastScore && lastScore[1] && <div><strong>{t('partial-report-categoria-1')}: </strong> {(Math.round(parseFloat(lastScore[1].Resultado) * 100))}%</div>}
                                {lastScore && lastScore[2] && <div><strong>{t('partial-report-categoria-2')}: </strong> {(Math.round(parseFloat(lastScore[2].Resultado) * 100))}%</div>}
                                {lastScore && lastScore[0] && <div><strong>{t('partial-report-categoria-0')}: </strong> {(Math.round(parseFloat(lastScore[0].Resultado) * 100))}%</div>}
                            </div>
                        </div>
                        <br />
                        {filterTeste &&
                            <div className="result">
                                {`${filterTeste[filterTeste.length - 1].NomeParte} // `}
                                {filterTeste[filterTeste.length - 1].Resultado && filterTeste[filterTeste.length - 1].Nivel ? `${filterTeste[filterTeste.length - 1].Resultado ? (Math.round(parseFloat(filterTeste[filterTeste.length - 1].Resultado) * 100)) : ''}%`
                                    : `Teste em andamento...`}
                                <br />
                                <strong style={{ fontSize: 'x-large', fontWeight: 'bold' }}>
                                    {filterTeste[filterTeste.length - 1].Nivel}
                                </strong>
                            </div>}
                    </div>
                </BoxWhite>
                }
            </DivStyled>
            <BoxWhite>
                <TestReports idTesteUser={params.idTesteUser} getLastScore={getLastScore} />
            </BoxWhite>
        </Col>
    </ContainerFlexStyled>

}

export default TestListDetails